module.exports = __webpack_public_path__ + "static/media/notice-3.f593382f.jpg";